import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack, Typography } from '@mui/material';

export type RoboOutcome = 'delivered' | 'abandoned' | 'returned';

const OPTIONS: Array<{ value: RoboOutcome; label: string; hint: string }> = [
  { value: 'delivered', label: 'Delivered', hint: 'The robo driver delivers the order.' },
  { value: 'abandoned', label: 'Abandoned', hint: 'Customer not available — the order is cancelled (delivery failed).' },
  { value: 'returned', label: 'Returned', hint: 'Abandoned, then the parcel goes back to the store.' },
];

/**
 * Test environments only (Loop robo courier on): which ending should the robo courier
 * play for the order being packed. Choosing one packs the order with it; Cancel packs
 * nothing.
 */
export default function RoboOutcomeDialog({ open, onChoose, onCancel }: {
  open: boolean;
  onChoose: (outcome: RoboOutcome) => void;
  onCancel: () => void;
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>🤖 Robo courier — how should this delivery end?</DialogTitle>
      <DialogContent>
        <Stack spacing={1.25} sx={{ mt: 0.5 }}>
          {OPTIONS.map((o) => (
            <Button key={o.value} variant="outlined" onClick={() => onChoose(o.value)} sx={{ justifyContent: 'flex-start', textAlign: 'left', py: 1 }}>
              <Stack>
                <Typography fontWeight={700}>{o.label}</Typography>
                <Typography variant="caption" color="text.secondary">{o.hint}</Typography>
              </Stack>
            </Button>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
